import * as types from '../mutations'
import _ from 'lodash'

const services = {
  template: window.abp.services.app.template
}

// initial state
const state = {
  all: [],
  pagination: {},
  activeTemplate: {},
  layouts: [
    {
      id: 'BF-basic-e-commerce',
      title: 'Basic e-commerce',
      img: '/static/assets/newsletter/BF-basic-e-commerce.png',
      src: '/static/assets/newsletter/BF-basic-e-commerce.json'
    },
    {
      id: 'BF-basic-newsletter',
      title: 'Basic newsletter',
      img: '/static/assets/newsletter/BF-basic-newsletter.png',
      src: '/static/assets/newsletter/BF-basic-newsletter.json'
    },
    {
      id: 'BF-basic-onecolumn',
      title: 'Basic one column',
      img: '/static/assets/newsletter/BF-basic-onecolumn.png',
      src: '/static/assets/newsletter/BF-basic-onecolumn.json'
    },
    {
      id: 'BF-basic-standard',
      title: 'Basic standard',
      img: '/static/assets/newsletter/BF-basic-standard.png',
      src: '/static/assets/newsletter/BF-basic-standard.json'
    },
    {
      id: 'BF-ecommerce-template',
      title: 'E-commerce',
      img: '/static/assets/newsletter/BF-ecommerce-template.png',
      src: '/static/assets/newsletter/BF-ecommerce-template.json'
    },
    {
      id: 'BF-newsletter-template',
      title: 'Newsletter',
      img: '/static/assets/newsletter/BF-newsletter-template.png',
      src: '/static/assets/newsletter/BF-newsletter-template.json'
    },
    {
      id: 'BF-promo-template',
      title: 'Promo',
      img: '/static/assets/newsletter/BF-promo-template.png',
      src: '/static/assets/newsletter/BF-promo-template.json'
    },
    {
      id: 'BF-simple-template',
      title: 'Simple',
      img: '/static/assets/newsletter/BF-simple-template.png',
      src: '/static/assets/newsletter/BF-simple-template.json'
    },
    {
      id: 'Empty Bee Template',
      title: 'Blank',
      img: '/static/assets/newsletter/BF-basic-standard.png',
      src: '/static/assets/newsletter/BF-blank-template.json'
    }
  ]
}

// getters
const getters = {
  allTemplates: state => state.all,
  allTemplatesPagination: state => state.pagination,
  activeTemplate: state => state.activeTemplate,
  templateLayouts: state => state.layouts
}

// actions
const actions = {
  getAllTemplates({ commit }, request) {
    if (!request) {
      request = {}
    }
    return new Promise((resolve, reject) => {
      services.template.getList(request).done(function (response) {
        let templates = response.items
        let pagination = {
          currentPage: response.currentPage,
          totalCount: response.totalCount,
          totalPage: response.totalPage
        }
        commit(types.DATA.RECEIVE_TEMPLATES, { templates, pagination })
        resolve()
      })
    })
  },
  getTemplate({ commit }, id) {
    let request = { id: id }
    return new Promise((resolve, reject) => {
      services.template.get(request).done(function (response) {
        commit(types.DATA.UPDATE_ACTIVE_TEMPLATE, response)
        resolve()
      })
    })
  },
  createOrUpdateTemplate({ commit }, template) {
    return new Promise((resolve, reject) => {
      let action = _.isEmpty(template.id) ? services.template.create(template) : services.template.update(template)
      action
        .done(function (response) {
          commit(types.DATA.REMOVE_VALIDATION_ERRORS)
          commit(types.DATA.UPDATE_ACTIVE_TEMPLATE, response)
          resolve()
        })
        .fail(function (response) {
          commit(types.DATA.SET_VALIDATION_ERRORS, response)
          reject()
        })
    })
  },
  deleteTemplate({ commit }, id) {
    return new Promise((resolve, reject) => {
      services.template.delete({ id: id })
        .done(function (response) {
          commit(types.DATA.REMOVE_VALIDATION_ERRORS)
          commit(types.DATA.UPDATE_ACTIVE_TEMPLATE, null)
          resolve()
        })
    })
  }
}

// mutations
const mutations = {
  [types.DATA.RECEIVE_TEMPLATES](state, { templates, pagination }) {
    state.all = templates
    state.pagination = pagination
  },
  [types.DATA.UPDATE_ACTIVE_TEMPLATE](state, template) {
    state.activeTemplate = template
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./scripts/store/modules/templates.js